import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { Controller, useForm } from "react-hook-form";

interface ActionFormWithDescriptionProps {
  title: string;
  buttonText: string;
  canExecute?: boolean;
  isLoading: boolean;
  onSubmit: (description: string) => void;
  // Prefix that derives `-heading`, `-description-input` and `-button` testids.
  dataTestId: string;
}

interface FormValues {
  description: string;
}

export function ActionFormWithDescription({
  title,
  buttonText,
  canExecute,
  isLoading,
  onSubmit,
  dataTestId,
}: ActionFormWithDescriptionProps) {
  const { control, handleSubmit } = useForm<FormValues>({
    defaultValues: { description: "" },
  });

  if (!canExecute) {
    return null;
  }

  const handleFormSubmit = ({ description }: FormValues) => {
    onSubmit(description.trim());
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Stack flexDirection="column" spacing={5}>
        <Typography
          variant="body1DashedDivider"
          data-testid={`${dataTestId}-heading-text`}
        >
          {title}
        </Typography>

        <Controller
          name="description"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Description"
              multiline
              rows={4}
              fullWidth
              slotProps={{
                htmlInput: { "data-testid": `${dataTestId}-description-input` },
              }}
            />
          )}
        />
        <Button
          variant="contained"
          size="large"
          fullWidth
          loading={isLoading}
          type="submit"
          data-testid={`${dataTestId}-button`}
        >
          {buttonText}
        </Button>
      </Stack>
    </form>
  );
}
